<template>
	<div class="row h-100 flex-center">

		<form-progress 
		:show="true" />

		<div class="col-lg-9 pt-0 px-6 px-md-0 pb-4">

			<slot name="before" />

			<form-layout />
			
		</div>

	</div>
</template>

<script>

	import FormLayout from '@components/forms/layouts/default/Layout'

	export default {

		components: {
			FormLayout
		}

	}
</script>